import styled from 'styled-components'

export const PrivacyPolicyMenuContainer = styled.section`
  display: flex;
  flex-direction: column;
`
export const PrivacyPolicyButtonContainer = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 1rem;
  padding-top: 1rem;
  border-bottom: 1px solid var(--gray200);
  width: 100%;
`
